import { createApp } from 'vue'
import App from './App.vue'
import registerDependencies from '@/plugins/registerDependencies'
import i18n from '@/plugins/i18n'
import router from './router/routerSetup'
import updateToken from '@/middleware/token-update'
import { FormValidationService } from '@es-bill/es-bill-common-components'

const app = createApp(App)

// Centralized dependency registration (logging, axios, pinia, vuetify, keycloak, services, globals)
registerDependencies(app)

// Provide common form validation service
const formValidationService = new FormValidationService(i18n.global.t)
app.config.globalProperties.$formValidation = formValidationService
app.provide('$formValidation', formValidationService)

// i18n before keycloak init to allow translated messages during bootstrap
app.use(i18n)

app.$log.info('setting up kc')

app.$keycloak
  .init({
    onLoad: 'login-required',
    // onLoad: 'check-sso',
    checkLoginIframe: false
  })
  .then((authenticated) => {
    app.$log.info('starting app, authenticated:' + authenticated)

    if (!authenticated) {
      window.location.reload()
      return
    }

    app.use(router)
    app.mount('#app')

    // Refresh token on focus and periodically
    window.onfocus = () => {
      updateToken(app)
    }
    setInterval(updateToken, 240000, app)
  })

